export const enumStatutFormation = {
    SUIVIE : 'Diplôme obtenu',
    ENCOURS : 'Formation en cours',
    AVENIR : 'Formation à venir'
}